import type { TRuleWithTheme } from '@/styles/theme';

export const actionsContainer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    columnGap: '1rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
});
